<template>
  <div class="tw-inline-block">
    <button
      type="button"
      ref="keyButton"
      @mousedown="handleDown"
      @mouseup="handleUp"
      class="tw-w-[50px] tw-h-[50px] tw-bg-primary tw-text-mainbg1 tw-m-[3px] tw-rounded-[3px] tw-pt-[7px]"
    >
      {{ value }}
    </button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  data: function () {
    return {
      isDelete: false,
      deleteTimeout: null as any,
      deleteLoop: null as any,
    };
  },
  props: ["value"],
  mounted() {
    let btn = this.$refs.keyButton as HTMLElement;
    btn.addEventListener("touchstart", this.handleDown);
    btn.addEventListener("touchend", this.handleUp);
    if (this.value.charCodeAt(0) == 8592) {
      this.isDelete = true;
    }
  },
  methods: {
    handleDown(e: Event) {
      e.preventDefault();
      if (this.isDelete) {
        this.handleDeleteLoop();
        this.deleteTimeout = setTimeout(this.handleStartDeleteLoop, 300);
      }
    },
    handleUp(e: Event) {
      e.preventDefault();
      if (this.isDelete) {
        clearTimeout(this.deleteTimeout);
        clearInterval(this.deleteLoop);
      } else {
        this.$emit("addchar", this.value);
      }
    },
    handleStartDeleteLoop() {
      this.deleteLoop = setInterval(this.handleDeleteLoop, 100);
    },
    handleDeleteLoop() {
      this.$emit("backspace");
    },
  },
});
</script>
